import React, { ReactElement } from 'react'

import getInnerChildren from './helpers/get-inner-children'
import getOuterChildren from './helpers/get-outer-children'
import { OuterLayoutRSC as OuterLayout } from './Partials/OuterLayoutRSC'
import { InnerLayoutRSC as InnerLayout } from './Partials/InnerLayoutRSC'
import { RetainBehaviorModifier, RetainSizeModifier } from '../../atoms/Retain/constants/modifiers'
import { Retain } from '../../atoms/Retain/Retain'
import { mergeDelegatedPanesIntoLayoutChildren } from './helpers/merge-delegated-panes'
import { convertChildrenToElementsArray } from './helpers/convert-children-to-elements-array'
import { determineSidebarState } from './Panes/helpers/determine-sidebar-state'
import { mergeRetainModifiers } from './helpers/merge-retain-modifiers'
import { LayoutProps } from './Types/layoutTypes'
import { ContentWrapper } from './Partials/ContentWrapper'

/**
 * @description
 * The Layout takes children, disects them and places them in a dom structure.
 *
 */
export const LayoutRSC = ({
    children,
    retainSize,
    retainBehaviorModifiers,
    noSpacingOnInnerLayout,
    notMain,
    noInnerScrolling,
}: LayoutProps): JSX.Element => {
    const childrenAsArray: ReactElement[] = convertChildrenToElementsArray(children)

    /** sepparates children in two groups so it can be passed to the InnerLayout and OuterLayout */
    const innerChildren = getInnerChildren(childrenAsArray)
    const outerChildren = getOuterChildren(childrenAsArray)

    return (
        <Retain
            behaviorModifiers={mergeRetainModifiers([RetainBehaviorModifier.NO_PADDING], retainBehaviorModifiers)}
            sizeModifier={RetainSizeModifier.FULL_WIDTH}
        >
            <ContentWrapper notMain={notMain}>
                <OuterLayout outerChildren={outerChildren}>
                    <InnerLayout
                        noScrolling={noInnerScrolling}
                        retainSize={retainSize}
                        innerChildren={innerChildren}
                        noPadding={noSpacingOnInnerLayout}
                        {...determineSidebarState(childrenAsArray)}
                        key="inner-layout"
                    />
                </OuterLayout>
            </ContentWrapper>
        </Retain>
    )
}
